import { getClient } from '@api/client';
import { graphql } from '@api/generated';
import { ServiceQueueSession } from '@modules/ServiceModule/workspace/types/ServiceQueue';

export const getQueueSessionsQuery = graphql(`
  query getQueueSessions($queueId: ID!) {
    queueSessions(queueId: $queueId) {
      id
      name
      position
      enteredAt
    }
  }
`);

export async function getQueueSessions(
  queueId: string,
  signal?: AbortSignal,
): Promise<{ sessions: ServiceQueueSession[] }> {
  const { data, error } = await getClient().query<{
    queueSessions: Array<{
      id: string;
      name: string;
      position: number;
      enteredAt: string;
    }>;
  }>({
    query: getQueueSessionsQuery,
    variables: { queueId },
    fetchPolicy: 'network-only',
    context: {
      fetchOptions: {
        signal,
      },
    },
  });

  if (error) {
    throw new Error(`Failed to fetch queue sessions: ${error.message}`);
  }

  const sessions: ServiceQueueSession[] = (data?.queueSessions ?? [])
    .map((s) => ({
      id: s.id,
      name: s.name,
      position: s.position,
      enteredAt: new Date(s.enteredAt),
    }))
    .sort(
      (a: ServiceQueueSession, b: ServiceQueueSession) =>
        a.enteredAt.getTime() - b.enteredAt.getTime(),
    );

  return { sessions };
}
